var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTvWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3945 17.9388H20.6055C22.1788 17.9388 23 17.1341 23 15.516V5.42274C23 3.80466 22.1788 3 20.6055 3H3.3945C1.82122 3 1 3.80466 1 5.42274V15.516C1 17.1341 1.82122 17.9388 3.3945 17.9388ZM9.82593 14.6064C9.37642 14.6064 9.01336 14.2653 9.01336 13.6443V7.28571C9.01336 6.66472 9.37642 6.33236 9.82593 6.33236C10.0507 6.33236 10.2409 6.40233 10.457 6.51604L15.6695 9.62099C16.0585 9.85714 16.2487 10.1195 16.2487 10.4606C16.2487 10.8105 16.0499 11.0816 15.6695 11.309L10.457 14.414C10.2409 14.5364 10.0507 14.6064 9.82593 14.6064ZM7.57839 21H16.4216C16.8538 21 17.2083 20.6414 17.2083 20.2041C17.2083 19.7668 16.8538 19.3994 16.4216 19.3994H7.57839C7.14617 19.3994 6.79175 19.7668 6.79175 20.2041C6.79175 20.6414 7.14617 21 7.57839 21Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTvWatch);
export default __webpack_public_path__ + "static/media/icon-tv-watch.5e5cf5fb5cc536fd8f79e211df90b20b.svg";
export { ForwardRef as ReactComponent };